var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEffemLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 9,
    viewBox: "0 0 38 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.4865 0.272728H29.7479L32.7138 7.51705H32.816L35.782 0.272728H37.0433V9H36.0547V2.36932H35.9695L33.2422 9H32.2876L29.5604 2.36932H29.4751V9H28.4865V0.272728Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.3146 9V0.272728H26.5817V1.21023H22.3714V4.15909H26.3089V5.09659H22.3714V8.0625H26.6499V9H21.3146Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2717 9V0.272728H19.5046V1.21023H15.3285V4.15909H19.1126V5.09659H15.3285V9H14.2717Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.22869 9V0.272728H12.4616V1.21023H8.28551V4.15909H12.0696V5.09659H8.28551V9H7.22869Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M0.0568161 9V0.272728H5.32386V1.21023H1.11363V4.15909H5.05113V5.09659H1.11363V8.0625H5.39204V9H0.0568161Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEffemLogo);
export default __webpack_public_path__ + "static/media/effem-logo.21404d208b9d2cbcf3d2606da2ba2d1b.svg";
export { ForwardRef as ReactComponent };